import Badge from './Badge.vue';
export default Badge; 